/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { ExtensibleNode } from '../../core/models/ExtensibleNode';
import { IIndexedNode } from '../../core/models/IIndexedNode';
import { IVisitor } from '../../core/visitors/IVisitor';
import { IOasVisitor } from '../visitors/IOasVisitor';

/**
 * Modles the OpenAPI paths.
 * @author eric.wittmann@gmail.com
 * @class
 * @extends ExtensibleNode
 */
export abstract class OasPaths extends ExtensibleNode implements IIndexedNode<OasPathItem> {
    /*private*/ _pathItems : any;

    /**
     * @see io.apicurio.datamodels.core.models.Node#accept(io.apicurio.datamodels.core.visitors.IVisitor)
     * @param {*} visitor
     */
    public accept(visitor : IVisitor) {
        let oasVisitor : IOasVisitor = <IOasVisitor><any>visitor;
        oasVisitor.visitPaths(this);
    }

    /**
     * Returns a single path item by name.
     * @param {string} name
     * @return {OasPathItem}
     */
    public getPathItem(name : string) : OasPathItem {
        return /* get */((m,k) => m[k]===undefined?null:m[k])(this._pathItems, name);
    }

    /**
     * Returns an array of all the path items.
     * @return {OasPathItem[]}
     */
    public getPathItems() : Array<OasPathItem> {
        let rval : Array<OasPathItem> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(rval, /* values */(obj => Object.keys(obj).map(key => obj[key]))(this._pathItems));
        return rval;
    }

    /**
     * Adds a path item.
     * @param {string} name
     * @param {OasPathItem} pathItem
     * @return {OasPathItem}
     */
    public addPathItem(name : string, pathItem : OasPathItem) : OasPathItem {
        /* put */(this._pathItems[name] = pathItem);
        return pathItem;
    }

    /**
     * Gets a list of all the path names.
     * @return {string[]}
     */
    public getPathItemNames() : Array<string> {
        let names : Array<string> = <any>([]);
        /* addAll */((l1, l2) => l1.push.apply(l1, l2))(names, /* keySet */Object.keys(this._pathItems));
        return names;
    }

    /**
     * Removes a single path item child model by name.
     * @param {string} path
     * @return {OasPathItem}
     */
    public removePathItem(path : string) : OasPathItem {
        return /* remove */(map => { let deleted = this._pathItems[path];delete this._pathItems[path];return deleted;})(this._pathItems);
    }

    /**
     * Creates an OAS path item object.
     * @param {string} path
     * @return {OasPathItem}
     */
    public abstract createPathItem(path : string) : OasPathItem;

    public addItem$java_lang_String$io_apicurio_datamodels_openapi_models_OasPathItem(name : string, item : OasPathItem) {
        this.addPathItem(name, item);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#addItem(java.lang.String, io.apicurio.datamodels.core.models.Node)
     * @param {string} name
     * @param {OasPathItem} item
     */
    public addItem(name? : any, item? : any) : any {
        if(((typeof name === 'string') || name === null) && ((item != null && item instanceof <any>OasPathItem) || item === null)) {
            return <any>this.addItem$java_lang_String$io_apicurio_datamodels_openapi_models_OasPathItem(name, item);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#deleteItem(java.lang.String)
     * @param {string} name
     * @return {OasPathItem}
     */
    public deleteItem(name : string) : OasPathItem {
        return this.removePathItem(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItem(java.lang.String)
     * @param {string} name
     * @return {OasPathItem}
     */
    public getItem(name : string) : OasPathItem {
        return this.getPathItem(name);
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItemNames()
     * @return {string[]}
     */
    public getItemNames() : Array<string> {
        return this.getPathItemNames();
    }

    /**
     * @see io.apicurio.datamodels.core.models.IIndexedNode#getItems()
     * @return {OasPathItem[]}
     */
    public getItems() : Array<OasPathItem> {
        return this.getPathItems();
    }

    constructor() {
        super();
        this._pathItems = <any>({});
    }
}
OasPaths["__class"] = "io.apicurio.datamodels.openapi.models.OasPaths";
OasPaths["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IIndexedNode"];





import { OasPathItem } from './OasPathItem';

